import IcGift from '@deliveryhero/pd-cookbook/components/Icons/IcGift';
import IcShow from '@deliveryhero/pd-cookbook/components/Icons/IcShow';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { ListItemIcon, MenuItem } from '@mui/material';

import { GiftCardState } from 'services/api';

import { GiftCardListingActionMenuProps } from './types';

export const GiftCardListingActionMenu = ({
  giftCard,
  handleView,
  handleSendEmail
}: GiftCardListingActionMenuProps) => {
  return (
    <>
      {giftCard.state == GiftCardState.COMPLETE &&
        giftCard.is_distribute_myself && (
          <MenuItem onClick={handleSendEmail}>
            <ListItemIcon>
              <IcGift fill="interaction-secondary" />
            </ListItemIcon>
            <Typography type="paragraph-sm" color="neutral-primary">
              Send details to my email
            </Typography>
          </MenuItem>
        )}
      <MenuItem onClick={handleView}>
        <ListItemIcon>
          <IcShow fill="interaction-secondary" />
        </ListItemIcon>
        <Typography type="paragraph-sm" color="neutral-primary">
          View details
        </Typography>
      </MenuItem>
    </>
  );
};
